import useMediaQuery from '@material-ui/core/useMediaQuery';
import { arrayOfNumbers } from './helpers/Utils';

export const DEVICE_QUERIES = {
  desktop: '(min-width: 700px)',
  mobile: '(max-width: 699px)',
  portrait: '(orientation: portrait)',
  landscape: '(orientation: landscape)',
  retina: '(min-resolution: 2dppx)',
};

export const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery('(min-width: 700px)');
  return isDesktop ? children : null;
};

export const Mobile = ({ children }) => {
  const isMobile = useMediaQuery('(max-width: 500px)');
  return isMobile ? children : null;
};

export const TAG_SIZE_OPTIONS = arrayOfNumbers();

export const STREET_SIZE_OPTIONS = arrayOfNumbers();

export const SLIDER_MAX = 10000;

export const STATE_OPTIONS = [
  'AK',
  'AL',
  'AR',
  'AS',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'GU',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MN',
  'MO',
  'MS',
  'MT',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'VI',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY',
];